export const detailsPageType = (type: string) => {
  switch (type) {
    case "PG:PLAYER:BOOKDETAILS":
      return false;
    case "PG:PLAYER:NOVELDETAILS":
      return false;
    case "PG:PLAYER:PODCASTDETAILS":
      return false;
    case "PG:PLAYER:JUZU":
      return false;
    case "PG:PLAYER:POEMS":
      return false;
    default:
      return true;
  }
};
